import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
    'providedIn': 'root'
})
export class LocalStorageService {
    // private storage = new Storage();
    private storage: Storage;

    // constructor(private storage: Storage) {
    // }

    public async initialize() {
        this.storage = new Storage();
        await this.storage['create']();
    }

    public async get(key: string): Promise<string> {
        const value = await this.storage['get'](key);
        return value || '';
    }

    public async set(key: string, value: string): Promise<any> {
        // return this.storage.set(key, value);
        return this.storage['set'](key, value);
    }

    // private addElementToArray(arrayName: string, value: string): Promise<{}> {
    //     const promise = new Promise((resolve, reject) => {
    //     this.get(arrayName)
    //         .then(obj => {
    //             const arr = this.utilsService.objectToArray(obj);
    //             arr.push(value);
    //             this.set(arrayName, arr.toString());
    //         });
    //     });
    //     return promise;
    // }

    // private removeElementFromArray(arrayName: string, value: string): Promise<{}> {
    //     const promise = new Promise((resolve, reject) => {
    //         this.get(arrayName)
    //         .then(obj => {
    //             const arr = this.utilsService.objectToArray(obj);
    //             const idx = arr.indexOf(value);
    //             if (idx !== -1) {
    //                 arr.splice(idx, 1);
    //             }
    //             this.set(arrayName, arr.toString());
    //         });
    //     });
    //     return promise;
    // }

    // Not Used!
    // public registerWatchPositionId(id): Promise<{}> {
    //     return this.addElementToArray('WatchPositionIds', id);
    // }

    // public unregisterWatchPositionId(id): Promise<{}> {
    //     return this.removeElementFromArray('WatchPositionIds', id);
    // }

    // public getWatchPositionIds(): Promise<{}> {
    //     const promise = new Promise((resolve, reject) => {
    //         this.get('WatchPositionIds')
    //         .then(obj => {
    //             const arr = this.utilsService.objectToArray(obj);
    //             resolve(arr);
    //         });
    //     });
    //     return promise;
    // }

    // See localStorage.service
    // public objectToArray(obj: any): any[] {
    //     const arr: any = [];
    //     _ . each(obj, function (item: any) {
    //         arr.push(item);
    //     });
    //     return arr;
    // }
}
